import { getLocalizedText } from 'ppbl/utils/locale-helper'

export const productTypes = ['app', 'app-renewal', 'paypal', 'paypal-renewal']

export const applicationStateList = [
  {
    primaryText: 'Alabama',
    value: 'AL',
  },
  {
    primaryText: 'Alaska',
    value: 'AK',
  },
  {
    primaryText: 'Arizona',
    value: 'AZ',
  },
  {
    primaryText: 'Arkansas',
    value: 'AR',
  },
  {
    primaryText: 'California',
    value: 'CA',
  },
  {
    primaryText: 'Colorado',
    value: 'CO',
  },
  {
    primaryText: 'Connecticut',
    value: 'CT',
  },
  {
    primaryText: 'Delaware',
    value: 'DE',
  },
  {
    primaryText: 'District Of Columbia',
    value: 'DC',
  },
  {
    primaryText: 'Florida',
    value: 'FL',
  },
  {
    primaryText: 'Georgia',
    value: 'GA',
  },
  {
    primaryText: 'Hawaii',
    value: 'HI',
  },
  {
    primaryText: 'Idaho',
    value: 'ID',
  },
  {
    primaryText: 'Illinois',
    value: 'IL',
  },
  {
    primaryText: 'Indiana',
    value: 'IN',
  },
  {
    primaryText: 'Iowa',
    value: 'IA',
  },
  {
    primaryText: 'Kansas',
    value: 'KS',
  },
  {
    primaryText: 'Kentucky',
    value: 'KY',
  },
  {
    primaryText: 'Louisiana',
    value: 'LA',
  },
  {
    primaryText: 'Maine',
    value: 'ME',
  },
  {
    primaryText: 'Maryland',
    value: 'MD',
  },
  {
    primaryText: 'Massachusetts',
    value: 'MA',
  },
  {
    primaryText: 'Michigan',
    value: 'MI',
  },
  {
    primaryText: 'Minnesota',
    value: 'MN',
  },
  {
    primaryText: 'Mississippi',
    value: 'MS',
  },
  {
    primaryText: 'Missouri',
    value: 'MO',
  },
  {
    primaryText: 'Montana',
    value: 'MT',
  },
  {
    primaryText: 'Nebraska',
    value: 'NE',
  },
  {
    primaryText: 'Nevada',
    value: 'NV',
  },
  {
    primaryText: 'New Hampshire',
    value: 'NH',
  },
  {
    primaryText: 'New Jersey',
    value: 'NJ',
  },
  {
    primaryText: 'New Mexico',
    value: 'NM',
  },
  {
    primaryText: 'New York',
    value: 'NY',
  },
  {
    primaryText: 'North Carolina',
    value: 'NC',
  },
  {
    primaryText: 'North Dakota',
    value: 'ND',
  },
  {
    primaryText: 'Ohio',
    value: 'OH',
  },
  {
    primaryText: 'Oklahoma',
    value: 'OK',
  },
  {
    primaryText: 'Oregon',
    value: 'OR',
  },
  {
    primaryText: 'Pennsylvania',
    value: 'PA',
  },
  {
    primaryText: 'Rhode Island',
    value: 'RI',
  },
  {
    primaryText: 'South Carolina',
    value: 'SC',
  },
  {
    primaryText: 'South Dakota',
    value: 'SD',
  },
  {
    primaryText: 'Tennessee',
    value: 'TN',
  },
  {
    primaryText: 'Texas',
    value: 'TX',
  },
  {
    primaryText: 'Utah',
    value: 'UT',
  },
  {
    primaryText: 'Vermont',
    value: 'VT',
  },
  {
    primaryText: 'Virginia',
    value: 'VA',
  },
  {
    primaryText: 'Washington',
    value: 'WA',
  },
  {
    primaryText: 'West Virginia',
    value: 'WV',
  },
  {
    primaryText: 'Wisconsin',
    value: 'WI',
  },
  {
    primaryText: 'Wyoming',
    value: 'WY',
  },
]

export const primaryLoanPurposeOptions = []

for (let i = 1; i <= 14; i++) {
  const primaryText = getLocalizedText(
    `application.applicationFields.primaryLoanPurpose.options.label${i}`,
  )
  const value = getLocalizedText(
    `application.applicationFields.primaryLoanPurpose.options.value${i}`,
  )
  primaryLoanPurposeOptions.push({ primaryText, value })
}

export const howDidYouHearAboutThisProductOptions = []

for (let i = 1; i <= 6; i++) {
  const primaryText = getLocalizedText(
    `application.applicationFields.howDidYouHearAboutThisProduct.options.label${i}`,
  )
  const value = getLocalizedText(
    `application.applicationFields.howDidYouHearAboutThisProduct.options.value${i}`,
  )
  howDidYouHearAboutThisProductOptions.push({ primaryText, value })
}

export const businessEntityTypeOptions = []
export const businessEntityTypeDecoder = {}

for (let i = 1; i <= 5; i++) {
  const label = getLocalizedText(
    `application.applicationFields.businessEntityType.options.label${i}`,
  )
  const value = getLocalizedText(
    `application.applicationFields.businessEntityType.options.value${i}`,
  )
  businessEntityTypeOptions.push({ label, value })
  businessEntityTypeDecoder[value] = label
}
